import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicFieldDropdown, DatePickerField } from 'core/components';
import { ApplicationEditLayout, Content } from "core/layouts";

const FacilityOrderEditTemplate = function({ facilityOrderEditViewStore }) {
	const {
		contentLoading,
		form,
		facilityStore
	} = facilityOrderEditViewStore;

	return (
		<ApplicationEditLayout store={facilityOrderEditViewStore}>
			<Content loading={contentLoading}>
				<React.Fragment>
					<div className="row">
						<div className="col col-sml-10 col-lrg-8">
							<div className="card card--form card--primary card--med">
								<div className="row">
									<div className="form__group col col-lrg-6 u-mar--bottom--sml">
										<BaasicFieldDropdown field={form.$('facilityId')} store={facilityStore}/>
									</div>
									<div className="form__group col col-lrg-6 u-mar--bottom--sml">
										<DatePickerField field={form.$('dateOfService')} disabled={form.$('dateOfService').disabled} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</React.Fragment>
			</Content>
		</ApplicationEditLayout>
	);
};

FacilityOrderEditTemplate.propTypes = {
	facilityOrderEditViewStore: PropTypes.object.isRequired,
	t: PropTypes.func,
};

export default defaultTemplate(FacilityOrderEditTemplate);